<script>
    import app from "../stores/app";
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import AccountControl from "../components/controls/AccountControl.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import HotelDepartments from "./HotelDepartments.svelte";
    import PageNotFound from "../components/pages/PageNotFound.svelte";
    import {setFocusTo, randomColor, scrollTo} from "../lib/lib";


    export let hotelId = null;
    export let updateCallback;
    export let breadcrumb = [{name: 'Hotels', link: `/app/hotel`}];

    export let account = null;

    let hotel = null;
    let pageTitle = '';
    let departmentId = null;
    let error = false;

    const initialize = () => {
        if (account) {
            breadcrumb = [...breadcrumb, {id: 'account', name: account.name, event: 'close_hotel'}];
        }

        scrollTo('top');

        if (hotelId == 0 || hotelId == 'create') {
            hotel = {
                id: 0,
                account_id: account ? account.id : null,
                color: randomColor(),
                name: '',
                contact_person: '',
                email: '',
                phone: '',
                mobile: '',
                address: '',
                notes: '',
                location_id: 0,
                is_active: 1,
                account: account,
                departments: [],
            };
            hotelId = 0;
            pageTitle = "New Hotel";
            setFocusTo('hotelName');
        } else {
            load();
        }
    }

    const load = () => {
        const onSuccess = result => {
            hotel = result;
            hotel.account_id = account ? account.id : null;
            pageTitle = hotel.name;
            setFocusTo('hotelName');
        }

        const onFailure = err => {
            error = true;
        };

        let data = {
            id: hotelId,
            account_id: account ? account.id : null,
        };
        R.handle(R.hotel.details, data, onSuccess, onFailure, LOADER.PAGE);
    };

    const save = () => {
        const onSuccess = result => {
            hotel = result;
            hotelId = result.id;
            pageTitle = hotel.name;
            updateCallback(hotel);
            Notifier.showMessage("Hotel saved");
        }

        const onFailure = err => {
            Alert.warning("Hotel", err.message);
        };

        hotel.name = hotel.name.trim();
        if (!hotel.name) {
            Notifier.showError("Type the name of the hotel!");
            setFocusTo('hotelName');
            return;
        }

        if (hotel.location_id == 0) {
            Notifier.showError("Select the region!");
            setFocusTo('region');
            return;
        }

        let action = hotel.id === 0 ? 'create' : 'edit';
        R.handle(R.hotel[action], hotel, onSuccess, onFailure, LOADER.POPUP);
    }

    const departmentsChange = (departments) => {
        hotel.departments = departments;
        updateCallback(hotel);
    }

    const close = () => {
        updateCallback();
    }


    initialize();
</script>

{#if !account}
    <Breadcrumb {breadcrumb}/>
{/if}
{#if hotel}
    <PageHeader title="{ pageTitle }" subtitle="{ account ? account.name : '' }"/>
    <div class="row">
        <div class="col-xl-6 col-lg-7 col-md-6">
            <div class="panel border-default mb-5">
                <div class="panel-body panel-pad">
                    <div class="form-group">
                        <h5>Hotel name</h5>
                        <input type="text" class="form-control" id="hotelName"
                               bind:value="{ hotel.name }" autocomplete="off">
                    </div>
                    <div class="row">
                        <div class="col-xl-6 col-lg-6">
                            <div class="form-group">
                                <label>Account</label>
                                <AccountControl bind:account="{ hotel.account }" bind:accountId="{ hotel.account_id }"
                                                disabled="{ account != null }"
                                />
                            </div>
                            <div class="form-group">
                                <label>Region</label>
                                <select class="form-select" id="region" bind:value={ hotel.location_id }>
                                    <option value="0">select region</option>
                                    {#each $app.regions as location}
                                        <option value="{ location.id }">{ location.name }</option>
                                    {/each}
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Address</label>
                                <input type="text" class="form-control" bind:value="{ hotel.address }"
                                       autocomplete="off">
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6">
                            <div class="form-group">
                                <label>Contact person</label>
                                <input type="text" class="form-control" bind:value="{ hotel.contact_person }"
                                       autocomplete="off">
                            </div>
                            <div class="form-group">
                                <label>Phone</label>
                                <input type="tel" class="form-control" bind:value="{ hotel.phone }"
                                       autocomplete="off">
                            </div>
                            <div class="form-group">
                                <label>Mobile</label>
                                <input type="tel" class="form-control" bind:value="{ hotel.mobile }"
                                       autocomplete="off">
                            </div>
                            <div class="form-group">
                                <label>Email</label>
                                <input type="email" class="form-control" bind:value="{ hotel.email }"
                                       autocomplete="off">
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label>Notes</label>
                        <textarea class="form-control" bind:value="{ hotel.notes }"></textarea>
                    </div>
                    <div class="form-group">
                        <Checkbox label="Active hotel" bind:checked={ hotel.is_active }/>
                    </div>

                    <hr>
                    <div class="text-end">
                        {#if account}
                            <button class="btn btn-link" on:click="{ close }">back to account</button>
                        {/if}
                        <button class="btn btn-primary px-4" on:click="{ save }">SAVE</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-lg-5 col-md-6">
            <HotelDepartments {hotel} changeHandler="{ departmentsChange }"/>
        </div>
    </div>
{/if}
{#if error}
    <PageNotFound message="Hotel not found!"/>
{/if}
